import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AgentDto, PermissionDto } from '../../../../service/dto';

@Component({
	selector: 'app-agent-permissions',
	standalone: false,
	templateUrl: './agent-permissions.component.html',
	styleUrl: './agent-permissions.component.scss'
})
export class AgentPermissionsComponent {
	_agent!: AgentDto;
	agentPermissions: PermissionDto[] = [];
	partnerPermissions: PermissionDto[] = [];
	importPermissions: PermissionDto[] = [];
	subscriberPermissions: PermissionDto[] = [];
	maskingPermissions: PermissionDto[] = [];
	systemPermissions: PermissionDto[] = [];

	constructor() { }

	@Input()
	set agent(input: AgentDto) {
		this._agent = input;
		this.agentPermissions = input.appRole!.permissions.filter(item => item.group == 'Agent');
		this.partnerPermissions = input.appRole!.permissions.filter(item => item.group == 'Partner');
		this.importPermissions = input.appRole!.permissions.filter(item => item.group == 'Import');
		this.subscriberPermissions = input.appRole!.permissions.filter(item => item.group == 'Subscriber');
		this.maskingPermissions = input.appRole!.permissions.filter(item => item.group == 'Masking');
		this.systemPermissions = input.appRole!.permissions.filter(item => item.group == 'System');
	}
	get agent(): AgentDto {
		return this._agent;
	}

	trackByHash(index: number, item: PermissionDto): any {
		return item.hashCode;
	}
	// trackByRole(index: number, item: RoleWrapper): any {
	// 	return item.roleId;
	// }
}
